import React from 'react';
import PageAuthorize from '../../../../security/PageAuthorize';
import ListContainer from '../../../../presentation/ListContainer';
import layout from './layout.json';

class ProgramInvoicesList extends React.Component {
  constructor( props ) {
    super( props );
    
    this.onFormatReadOnlyCellLabel = this.onFormatReadOnlyCellLabel.bind( this );
  }
  onFormatReadOnlyCellLabel( args ) {
     
    /* Highlight Entity if it is different that BillTo */
    if( args.column === 'ENTITY_NAME' ) {
      const row = args.rows[ args.rowIndex ];
      if( row !== undefined ) {
        const Entity_ID = parseInt( row['ENTITY_ID'], 10 );
        const BillTo_ID = parseInt( row['BILLTO_ID'], 10 );
        if( Entity_ID !== BillTo_ID ) {
          args.styles['borderRadius'] = '4px';
          args.styles['padding'] = '5px';
          args.styles['backgroundColor'] = 'yellow';
        }
      }
    }

    /* Highlight Program Active Flag if it is N */
    if( args.column === 'PROGRAM_ACTIVE_TEXT' ) {

      if( args.value === 'Y' ) {
        args.styles['borderRadius'] = '4px';
        args.styles['padding'] = '5px';
        args.styles['fontWeight'] = 'bold';
        args.styles['color'] = 'white';
        args.styles['backgroundColor'] = 'green';
      }      

      if( args.value === 'N' ) {
        args.styles['borderRadius'] = '4px';
        args.styles['padding'] = '5px';
        args.styles['fontWeight'] = 'bold';
        args.styles['color'] = 'white';
        args.styles['backgroundColor'] = 'red';
      }      
      
      if( args.value === 'P' ) {
        args.styles['borderRadius'] = '4px';
        args.styles['padding'] = '5px';
        args.styles['fontWeight'] = 'bold';
        args.styles['color'] = 'white';
        args.styles['backgroundColor'] = 'blue';
      }      
    }
  }

  render(){
    return (
      <PageAuthorize groups={['Administrators','Operations','Accounting']}>
        <ListContainer
          id="ProgramInvoicesList"
          layout={layout}
          selectedtab={3}
          onFormatReadOnlyCellLabel={this.onFormatReadOnlyCellLabel}
        />
      </PageAuthorize>
    );
  }
}

export default ProgramInvoicesList;



// WEBPACK FOOTER //
// ./src/content/accounting/programinvoices/components/ProgramInvoices.js